import styled from 'styled-components'

export const Form = styled.form`
  height: 100%;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
`

export const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow: auto;
  padding: 20px;

  > div > div {
    width: 100% !important;
  }
`
